import React, { Component } from "react";
import { Col } from "reactstrap";
import { db } from "../../firebase/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";

class PostDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
       ...props,
       isSelected: false,
       clickLike: false
    }
  }

  handleDetail = (e) => {
    this.setState({
      isSelected: !this.state.isSelected,
    });
  }
  handleLike = (e) =>  {
    const { like } = this.state.info;
    const { clickLike } = this.state;
    const heart = e.target;
    
    if (clickLike){
      this.setState({
        info: {...this.state.info, like: like-1},
        clickLike: !clickLike,
      });
      heart.style.color = '#a6a6a6';
      this.decreLike();
    } else {
      this.setState({
        info: {...this.state.info, like: like+1},
        clickLike: !clickLike,
      });
      heart.style.color = '#ff6b8c';
      this.increLike();
    }
  }
  increLike = () =>  {
    const { postId, like } = this.state.info
    db.collection('Post').doc(postId).update({
      like: like+1
    });
  }
  decreLike = () =>  {
    const { postId, like } = this.state.info
    db.collection('Post').doc(postId).update({
      like: like-1
    });
  }

  render(){
    const { like, register, url } = this.state.info;
    const { isSelected} = this.state;
    // console.log(this.state);
    return(
      <Col xs={isSelected ? "12" : "4" } className={isSelected ? "post-detail selected" : "post-detail" }>
        <img src={url} onClick={this.handleDetail} alt="temp"/>
        <div className={isSelected ? "post-info" : "post-info hidden"}>
          <div>{register}</div>
          <div><span className="like" onClick={this.handleLike}><FontAwesomeIcon icon={faHeart} /></span> {like}</div>
        </div>
      </Col>
    );
  }
}
export default PostDetail;